import * as React from 'react';
import Cookies from 'js-cookie';
import { RouteComponentProps } from 'react-router';
import { SecuredPage } from '../base/secured-page';
import { LinkButton } from '../../components/link-button/link-button';
import { logout } from '../../api/actions/logout-action';
import { AppConfig } from '../../config/app-config';
import { useUser } from '../../contexts/user-context';
import softCurve from './imgs/white-bg.png';
import upperLeftCloud from './imgs/clouds-logo.png';
import logo from './imgs/logo.png';
import screenShot from './imgs/screenshot.png';

export const HumiePage: React.FC<RouteComponentProps> = (props) => {
  const { setUser } = useUser();

  const colors = {
    primaryPurple: '#8B56A5',
    secondaryPurpleWithOpacity: 'rgba(128, 0, 128, 0.1)',
    secondaryGray: 'rgba(0, 0, 0, 0.4)',
    homeBlue: '#86D3F8',
    learnGray: '#E7E8F5',
    primaryYellow: '#FCD172',
    secondaryYellow: '#F9ECA6',
    primaryWhite: '#FEFEFA',
    primaryBlack: '#343434',
  };

  const logOut = async () => {
    try {
      await logout();
      localStorage.removeItem('user');
      setUser(null);
    } catch {
      console.log('error logging out');
    }

    Cookies.remove(AppConfig.tokenName);
    document.location.href = '/login';
  };

  return (
    <SecuredPage pageName="humie" {...props}>
      <div
        style={{ backgroundColor: colors.secondaryYellow }}
        className="h-screen relative overflow-hidden"
      >
        <div className="absolute left-0 top-0">
          <img src={upperLeftCloud} className="w-3/4 sm:w-full" />
          <img
            className="absolute z-10 left-12 sm:left-16 top-2 sm:top-5"
            src={logo}
            alt="Logo"
          />
        </div>
        <div className="absolute right-0 top-0 w-1/3 sm:w-2/5 h-full z-0">
          <img
            className="w-full h-full object-cover object-left"
            src={softCurve}
            alt="Humie app background"
          />
        </div>
        <div className="absolute top-5 right-5 z-20">
          <LinkButton onClick={logOut} className="text-sm text-[#8B56A5]">
            Logout
          </LinkButton>
        </div>

        <div className="flex justify-center h-full pt-[100px] lg:pt-0">
          <div className="relative z-10 w-[85%] lg:w-[90%] flex flex-col lg:flex-row items-center gap-8 lg:gap-12 px-4 lg:px-8 py-8">
            <div className="flex-shrink-0 lg:flex-[0_0_40%] flex justify-end">
              <div className="max-w-xl">
                <div className="flex-col flex-shrink inline-block">
                  <h1
                    className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 text-left"
                    style={{ color: colors.primaryPurple }}
                  >
                    Welcome <br /> to Humie TV!
                  </h1>
                  <p
                    className="text-lg md:text-xl font-bold mb-8"
                    style={{ color: colors.primaryPurple }}
                  >
                    Download Humie today and help <br /> your child grow kinder,
                    wiser, and <br /> more self-aware.
                  </p>
                  <button
                    onClick={() =>
                      window.open(
                        'https://apps.apple.com/us/app/humie-tv/id6504301234',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                    className="text-white text-lg md:text-xl font-bold uppercase px-6 md:px-8 py-3 md:py-4 rounded-full hover:opacity-90 transition-opacity outline-none border-none"
                    style={{
                      backgroundColor: colors.primaryPurple,
                      border: 'none',
                    }}
                  >
                    Download Now
                  </button>
                </div>
              </div>
            </div>

            <div className="flex-1 flex items-center justify-center -mt-16 lg:mt-0">
              <div
                className="bg-white p-5 rounded-[10px] shadow-[8px_8px_0px_rgba(134,211,248,1)]"
                style={{
                  boxShadow: `8px 8px 0px ${colors.homeBlue}`,
                }}
              >
                <img
                  src={screenShot}
                  alt="Humie app preview"
                  className="w-full h-auto max-w-[537px] block"
                  style={{ maxWidth: '100%', height: 'auto' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </SecuredPage>
  );
};
